if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Keep the spinner behavior for the button clicked
      const submitButton = evt.submitter || this.querySelector('[type="submit"]');
      const spinner = submitButton.querySelector('.loading-overlay__spinner');
      
      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const mainProductId = this.form.querySelector('[name=id]').value;
      
      // Original quantity handling logic (without nearest search)
      const mainProductQuantityElement = this.form.querySelector('[name=quantity]');
      const mainProductQuantity = mainProductQuantityElement ? mainProductQuantityElement.value : 1;

      const giftWrapCheckbox = this.form.querySelector('.product-gift-wrap input[type="checkbox"]');
      const giftWrapVariantId = giftWrapCheckbox ? giftWrapCheckbox.value : null;

      const personalisationCheckbox = this.form.querySelector('.product-personalisation-wrap input[type="checkbox"]');
      const personalisationVariantId = personalisationCheckbox ? personalisationCheckbox.value : null;

      const personalisationTextArea = this.form.querySelector('#allergies');
      const personalisationError = this.form.querySelector('#personalisationError');

      // Check if personalisation checkbox is checked but personalisation text area is empty
      if (personalisationCheckbox && personalisationCheckbox.checked && (!personalisationTextArea || personalisationTextArea.value.trim() === '')) {
        personalisationError.innerText = "Please fill in the personalization field.";
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return; // Stop form submission
      }

      const properties = {};
      this.form.querySelectorAll('[name^="properties"]').forEach((input) => {
        properties[input.name] = input.value;
      });

      formData.delete('id'); // Ensure no single 'id' field is present
      formData.append('items[0][id]', mainProductId);
      formData.append('items[0][quantity]', mainProductQuantity);
      Object.keys(properties).forEach(key => {
        formData.append(`items[0][${key}]`, properties[key]);
      });

      let itemIndex = 1;
      if (giftWrapCheckbox && giftWrapCheckbox.checked) {
        formData.append(`items[${itemIndex}][id]`, giftWrapVariantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
        itemIndex++;
      }

      if (personalisationCheckbox && personalisationCheckbox.checked) {
        formData.append(`items[${itemIndex}][id]`, personalisationVariantId);
        formData.append(`items[${itemIndex}][quantity]`, 1);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: mainProductId, errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: mainProductId});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
